import { Product as ProductType, Variant, Variations } from '@framework/model-types/Product'
import { Dispatch, SetStateAction, createContext, useContext } from 'react'
import { KeyedMutator } from 'swr'

export const ProductPageContext = createContext<{
  product: ProductType
  selectedVariation: Variant | null
  mutateAPIProductData: KeyedMutator<any> | undefined
  setSelectedVariation: Dispatch<SetStateAction<Variant | null>>
  showProductSpecs: boolean
  attributes: Record<string, string>,
  setAttributes: Dispatch<SetStateAction<Record<string, string>>>,
  variations: Variations,
}>({
  product: {} as ProductType,
  mutateAPIProductData: undefined,
  selectedVariation: null,
  setSelectedVariation: () => {},
  showProductSpecs: false,
  attributes: {},
  setAttributes: () => {},
  variations: [],
})


export const useProductPage = () => {
  const context = useContext(ProductPageContext)
  if (context === undefined) {
    throw new Error(`useProductPage must be used within a ProductPageContextProvider`)
  }
  return context
}
